import { Params } from '@angular/router';
import { IDeliveryCustomerOrder } from 'src/app/features/deliveries/models/delivery.models';
import { normalizeEntityId } from 'src/app/shared/helpers/entity-id.helper';

export interface GridCellLink {
    routerLink: string | unknown[];
    queryParams?: Params | null;
}

/** `/articles?id={id}` — articles list opens the right panel for that article. */
export function articleGridRouterLink(articleId: unknown): GridCellLink | null {
    const id = normalizeEntityId(articleId);
    return entityGridRouterLink(['/articles'], id);
}

/** `/{segment}/:id` entity detail routes. */
export function entityGridRouterLink(baseSegments: string | string[], entityId: unknown): GridCellLink | null {
    const id = normalizeEntityId(entityId);
    if (!id) return null;
    const segments = Array.isArray(baseSegments) ? baseSegments : [baseSegments];
    return { routerLink: [...segments, id] };
}

export function customerGridRouterLink(customerId: unknown): GridCellLink | null {
    return entityGridRouterLink(['/customers'], customerId);
}

export function orderGridRouterLink(orders: Partial<IDeliveryCustomerOrder[]>): GridCellLink | null {
    if (!orders.length || orders.length > 1) return null;

    return entityGridRouterLink(['/orders'], orders[0].id);
}

export function customerOrderGridRouterLink(orderId: unknown): GridCellLink | null {
    return entityGridRouterLink(['/orders'], orderId);
}

export function deliveryGridRouterLink(deliveryId: unknown): GridCellLink | null {
    return entityGridRouterLink(['/deliveries'], deliveryId);
}

/** Link only when the invoice has exactly one delivery (same rule as order links). */
export function invoiceDeliveriesGridRouterLink(deliveries: { id?: unknown }[] | null | undefined): GridCellLink | null {
    if (!deliveries?.length || deliveries.length > 1) {
        return null;
    }
    return deliveryGridRouterLink(deliveries[0].id);
}

export function invoiceGridRouterLink(invoiceId: unknown): GridCellLink | null {
    return entityGridRouterLink(['/invoices'], invoiceId);
}
